module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container col-sm-12 col-xs-12"
  }, [_c('h3', {
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.mobileNumber))])]), _vm._v(" "), (_vm.codeSent) ? _c('div', [(_vm.errorMsg) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('p', [_vm._v(_vm._s(_vm.errorMsg))])]) : _vm._e(), _vm._v(" "), (_vm.alertMsg) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.alertMsg))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.codeSent) ? _c('div', [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.sendCode()
      }
    }
  }, [_vm._v("Generate Code")]), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), (_vm.pending) ? _c('div', {
    staticClass: "form-group"
  }, [(_vm.codeSent) ? _c('div', [_c('div', {
    staticClass: "col-xs-6 remove-margins"
  }, [(_vm.pending) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "form-control",
    attrs: {
      "pattern": "\\d*",
      "type": "text",
      "placeholder": "Verification Code",
      "maxlength": "6",
      "autocorrect": "off",
      "autocomplete": "off",
      "autocapitalize": "off",
      "spellcheck": "false"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [(_vm.pending) ? _c('button', {
    staticClass: "btn btn-info",
    staticStyle: {
      "font-size": "small !important"
    },
    attrs: {
      "disabled": _vm.count > 1
    },
    on: {
      "click": function($event) {
        _vm.sendCode()
      }
    }
  }, [_vm._v("Re-Send Code " + _vm._s(_vm.count) + " ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.notReceiving) ? _c('div', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.notReceivingMessages()
      }
    }
  }, [_vm._v("Not receiving messages?")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.closePhone()
      }
    }
  }, [_vm._v("Close")])])]) : _vm._e(), _vm._v(" "), (!_vm.pending) ? _c('button', {
    staticClass: "btn btn-default pull-right",
    on: {
      "click": function($event) {
        _vm.closePhone()
      }
    }
  }, [_vm._v("Close")]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info"
  }, [_c('p', [_vm._v("We will generate a 6 digit code and send it to your registered phone, press Generate Code when you are ready")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-63c6db61!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Account/VerifyPhone.vue
// module id = 636
// module chunks = 2